module.exports = __webpack_public_path__ + "static/media/postConferenceTours.02ab53bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/apps/BCOMS/resources/postConferenceTours.png
// module id = 1121
// module chunks = 0